export default __webpack_public_path__ + "static/media/butler.8be65458.svg";